import React from 'react';
import { size, isUndefined } from 'lodash';
import { CircularProgress } from '@mui/material';
import RenderImageLoader from '../../../common/components/Form/RenderImageLoader';
import APIClient from '../../../common/services/APIClient';
import { REACT_APP_API_URL } from '../../../config';
import ShowUploadErrorMessage from './ChargerDetailsFormRenderers/showUploadErrorMessage';
import { notJsFile } from '../../../common/services/ValidationRules';

const base64img = 'data:image;base64,';

class ChargerDetailsImages extends React.PureComponent {
  constructor(props) {
    super(props);
    this.initialPictureKeys = props.pictureKeys;
    this.handleRemoveImage = this.handleRemoveImage.bind(this);
    this.handleLoadImage = this.handleLoadImage.bind(this);
    this.setPhotoIndex = this.setPhotoIndex.bind(this);
    this.state = {
      loading: true,
      photoIndex: 0,
      images: [],
      uploadError: null,
    };
  }

  setPhotoIndex(index) {
    this.setState({ photoIndex: index });
  }

  getImageURL(path) {
    return `${REACT_APP_API_URL}/media/${path}`;
  }

  async getImageSource(pictureKey) {
    const response = await APIClient.get(this.getImageURL(pictureKey));

    return base64img + response.data;
  }

  componentDidMount() {
    this.getImages(this.initialPictureKeys)
      .then((images) => {
        this.setState({ images });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ images: [] });
      })
      .finally(() => this.setState({ loading: false }));
  }

  getImages(pictureKeys) {
    return Promise.all(pictureKeys.map(async (item) => ({
      url: await this.getImageSource(item),
      key: item,
    })));
  }

  handleUploadError(error) {
    if (error.response.data && error.response.data.errors) {
      this.setState({
        uploadError: error.response.data.errors.map((err) => err.message).join(', '),
      });
    } else {
      this.setState({ uploadError: error.message });
    }

    setTimeout(() => {
      this.setState({ uploadError: null });
    }, 500);
  }

  handleLoadImage(imageBlob) {
    const data = new FormData();

    data.append('file', imageBlob);

    const checkFile = notJsFile({ file: imageBlob });

    if (!isUndefined(checkFile)) {
      return this.handleUploadError({ message: checkFile, response: { data: null } });
    }

    APIClient.post('/files/temp', data)
      .then(({ data }) => {
        const otherImages = this.state.images
          .filter((image) => image.key !== data);

        const newImageUrl = this.getImageURL(data);
        const parent = this;

        APIClient.get(newImageUrl)
          .then((res) => {
            parent.setState({
              images: [...otherImages, { url: base64img + res.data, key: data }],
            }, () => {
              parent.updatePictureKeys(parent.state.images);
              parent.setPhotoIndex(size(parent.state.images) - 1);
            });
          });
      })
      .catch((error) => {
        this.handleUploadError(error);
      });
  }

  handleRemoveImage(activeImage) {
    this.setState((prevState) => ({
      images: prevState.images.filter((image) => image.key !== activeImage.key),
    }), () => {
      this.updatePictureKeys(this.state.images);
      this.setPhotoIndex(0);
    });
  }

  updatePictureKeys(images) {
    const pictureKeys = images
      .filter((image) => image.key)
      .map((image) => image.key);

    this.props.onChange(pictureKeys);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.isPicturesReset(nextProps)) {
      this.getImages(nextProps.pictureKeys)
        .then((images) => {
          this.setState({ images });
        })
        .catch((err) => {
          console.error(err);
          this.setState({ images: [] });
        })
        .finally(() => this.setState({ loading: false }));
    }
  }

  isPicturesReset(nextProps) {
    return this.props !== nextProps && nextProps.pictureKeys === this.initialPictureKeys;
  }

  render() {
    const { label, subLabel, readOnly } = this.props;
    const { images, photoIndex, loading } = this.state;

    if (loading) {
      return <CircularProgress size={20} />;
    }

    return (
      <>
        <RenderImageLoader
          photoIndex={photoIndex}
          setPhotoIndex={this.setPhotoIndex}
          images={images}
          label={label}
          subLabel={subLabel}
          readOnly={readOnly}
          onLoad={this.handleLoadImage}
          onRemove={this.handleRemoveImage}
        />
        <ShowUploadErrorMessage message={this.state.uploadError} />
      </>
    );
  }
}

export default ChargerDetailsImages;
